import {
  MODULE_METADATA_ERROR,
  MODULE_METADATA_REQUEST,
  MODULE_METADATA_SUCCESS,
} from "../../../actionTypes";
import { ModulesActionTypes, SModuleMetadata } from "../../../types";

const initialState: SModuleMetadata = {
  isFetching: false,
};

const moduleReducer = (
  state = initialState,
  action: ModulesActionTypes
): SModuleMetadata => {
  switch (action.type) {
    case MODULE_METADATA_REQUEST:
      return {
        ...state,
        isFetching: true,
      };

    case MODULE_METADATA_SUCCESS:
      return {
        ...state,
        ...action.payload,
        isFetching: false,
      };

    case MODULE_METADATA_ERROR:
      return {
        ...state,
        isFetching: false,
      };

    default:
      return state;
  }
};

export default moduleReducer;
